import { render, staticRenderFns } from "./SamplePagination.vue?vue&type=template&id=260d1888&"
import script from "./SamplePagination.vue?vue&type=script&lang=js&"
export * from "./SamplePagination.vue?vue&type=script&lang=js&"
import style0 from "./SamplePagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports